import { render } from "./SignOffCells.vue?vue&type=template&id=723c0d26&ts=true"
import script from "./SignOffCells.vue?vue&type=script&lang=ts"
export * from "./SignOffCells.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__